app.controller('purchaseSummaryCtrl', function ($scope, urlServices, toaster) {
    $scope.hasSubmitted = false;
    $scope.activeSettings = null;
    $scope.datePicker = {
        startDate: moment().subtract(30, 'days'),
        endDate: moment()
    };
    $scope.summary = {
        TotalTransaksi: 0,
        TotalItem: 0,
        TotalNaik: 0,
        TotalTurun: 0,
        CostSavingPurchasing: 0
    };
    $scope.months = [];
    $scope.priorityMatrix = [];
    $scope.priorityDirectionSummary = [];
    $scope.categorySummary = [];
    $scope.detailModal = {
        visible: false,
        loading: false,
        title: '',
        periodMonth: '',
        direction: '',
        exportUrl: '',
        data: []
    };

    function appendRequestStamp(query) {
        return query + (query ? '&' : '') + '_ts=' + new Date().getTime();
    }

    function formatPeriodSetting(setting) {
        if (!setting) {
            return '-';
        }
        return [String(setting.mode || '-'), String(setting.lookback || '-'), String(setting.unit || '-')].join(' / ');
    }

    function formatMonthLabel(value) {
        return value ? moment(value).format('MMMM YYYY') : '';
    }

    function attachMonthGrouping(rows) {
        var currentKey = null;
        var currentStartIndex = -1;
        var currentCount = 0;

        (rows || []).forEach(function (item, index) {
            item.showMonthCell = false;
            item.monthRowspan = 0;
            if (item.BulanKey !== currentKey) {
                if (currentStartIndex >= 0) {
                    rows[currentStartIndex].showMonthCell = true;
                    rows[currentStartIndex].monthRowspan = currentCount;
                }
                currentKey = item.BulanKey;
                currentStartIndex = index;
                currentCount = 1;
            } else {
                currentCount += 1;
            }
        });

        if (currentStartIndex >= 0) {
            rows[currentStartIndex].showMonthCell = true;
            rows[currentStartIndex].monthRowspan = currentCount;
        }
        return rows;
    }

    $scope.getActiveSettingsSummary = function () {
        var settings = $scope.activeSettings || {};
        var dist = settings.priorityDistribution || {};
        return {
            rankPeriod: formatPeriodSetting(settings.rankPeriod),
            previousPricePeriod: formatPeriodSetting(settings.previousPricePeriod),
            distribution: 'P1 ' + (dist.p1 || 0) + '% | P2 ' + (dist.p2 || 0) + '% | P3 ' + (dist.p3 || 0) + '% | P4 ' + (dist.p4 || 0) + '%',
            specialNominal: dist.specialNominal || 0,
            categoryCount: (settings.categoryCodes || []).length
        };
    };

    $scope.loadSettings = function () {
        urlServices.ambilData('api/report/purchase-history-settings', {}, function (err, sukses) {
            if (err) {
                $scope.activeSettings = null;
                return;
            }
            $scope.activeSettings = sukses.data ? sukses.data : sukses;
        });
    };

    $scope.tampilkan = function () {
        var start = moment($scope.datePicker.startDate);
        var end = moment($scope.datePicker.endDate);
        if (!start.isValid() || !end.isValid()) {
            toaster.pop('error', 'Error', 'Periode belum valid');
            return;
        }
        if (end.isBefore(start)) {
            toaster.pop('error', 'Error', 'Tanggal akhir tidak boleh lebih kecil dari tanggal awal');
            return;
        }
        $scope.hasSubmitted = true;
        $scope.getData();
    };

    $scope.resetFilter = function () {
        $scope.hasSubmitted = false;
        $scope.datePicker = {
            startDate: moment().subtract(30, 'days'),
            endDate: moment()
        };
        $scope.summary = {
            TotalTransaksi: 0,
            TotalItem: 0,
            TotalNaik: 0,
            TotalTurun: 0,
            CostSavingPurchasing: 0
        };
        $scope.months = [];
        $scope.priorityMatrix = [];
        $scope.priorityDirectionSummary = [];
        $scope.categorySummary = [];
        $scope.closeDetailModal();
    };

    $scope.closeDetailModal = function () {
        $scope.detailModal.visible = false;
        $scope.detailModal.loading = false;
        $scope.detailModal.title = '';
        $scope.detailModal.periodMonth = '';
        $scope.detailModal.direction = '';
        $scope.detailModal.exportUrl = '';
        $scope.detailModal.data = [];
    };

    $scope.exportDetailExcel = function () {
        if ($scope.detailModal.loading || !$scope.detailModal.exportUrl || !$scope.detailModal.data.length) {
            return;
        }
        window.open($scope.detailModal.exportUrl, '_blank');
    };

    $scope.openSummaryDetail = function (options) {
        options = options || {};
        var nominal = Number(options.nominal || 0);
        if (!nominal) {
            return;
        }

        var start = moment($scope.datePicker.startDate);
        var end = moment($scope.datePicker.endDate);
        $scope.detailModal.visible = true;
        $scope.detailModal.loading = true;
        $scope.detailModal.periodMonth = options.periodMonth || '';
        $scope.detailModal.direction = options.direction || 'all';
        $scope.detailModal.title = options.title || 'Detail Summary';
        $scope.detailModal.exportUrl = '';
        $scope.detailModal.data = [];

        var query = 'start_date=' + start.format('YYYY-MM-DD') + '&end_date=' + end.format('YYYY-MM-DD');
        if (options.periodMonth) {
            query += '&period_month=' + encodeURIComponent(options.periodMonth);
        }
        if (options.direction) {
            query += '&direction=' + encodeURIComponent(options.direction);
        }
        if (options.priority) {
            query += '&priority=' + encodeURIComponent(options.priority);
        }
        if (options.categoryCode) {
            query += '&category_code=' + encodeURIComponent(options.categoryCode);
        }
        query += '&context=summary';
        query = appendRequestStamp(query);

        $scope.detailModal.exportUrl = '/api/report/purchase-summary-detail?' + query + '&excel=1';

        urlServices.ambilData('api/report/purchase-summary-detail?' + query, {}, function (err, sukses) {
            $scope.detailModal.loading = false;
            if (err) {
                toaster.pop('error', 'Error', err);
                $scope.detailModal.exportUrl = '';
                $scope.detailModal.data = [];
                return;
            }
            $scope.detailModal.data = sukses.data || [];
        });
    };

    $scope.getData = function () {
        var start = moment($scope.datePicker.startDate);
        var end = moment($scope.datePicker.endDate);
        var query = 'start_date=' + start.format('YYYY-MM-DD') + '&end_date=' + end.format('YYYY-MM-DD');

        urlServices.ambilData('api/report/purchase-summary?' + query, {}, function (err, sukses) {
            if (err) {
                toaster.pop('error', 'Error', err);
                $scope.summary = {
                    TotalTransaksi: 0,
                    TotalItem: 0,
                    TotalNaik: 0,
                    TotalTurun: 0,
                    CostSavingPurchasing: 0
                };
                $scope.months = [];
                $scope.priorityMatrix = [];
                $scope.priorityDirectionSummary = [];
                $scope.categorySummary = [];
                return;
            }

            $scope.summary = sukses.summary || $scope.summary;
            $scope.months = sukses.months || [];
            $scope.priorityMatrix = sukses.priorityMatrix || [];
            $scope.priorityDirectionSummary = attachMonthGrouping((sukses.priorityDirectionSummary || []).map(function (item) {
                item.BulanLabel = formatMonthLabel(item.BulanDate);
                return item;
            }));
            $scope.categorySummary = attachMonthGrouping((sukses.categorySummary || []).map(function (item) {
                item.BulanLabel = formatMonthLabel(item.BulanDate);
                return item;
            }));
            $scope.activeSettings = sukses.settings || $scope.activeSettings;
            $scope.closeDetailModal();
        });
    };

    $scope.loadSettings();
});